import { InfoCircle } from '@byway/icons';
import { useTranslations } from 'next-intl';
import type { ReactNode } from 'react';
import { Button as RAC_Button, DialogTrigger as RAC_DialogTrigger } from 'react-aria-components';
import { Popover } from '~/components/Popover';
import type { TooltipProps } from './Tooltip.types';

interface InfoPopoverProps {
  children: ReactNode;
  placement?: TooltipProps['placement'];
  ariaLabel: string;
}

function InfoPopover({ children, placement = 'bottom', ariaLabel }: InfoPopoverProps) {
  return (
    <RAC_DialogTrigger>
      <RAC_Button aria-label={ariaLabel}>
        <InfoCircle decorative strokeWidth={2} />
      </RAC_Button>
      <Popover hasArrow placement={placement} ariaLabel={ariaLabel}>
        {children}
      </Popover>
    </RAC_DialogTrigger>
  );
}

export { InfoPopover };
